<ng-template [ngTemplateOutlet]="uiPlaceHolderTemplate"></ng-template>
<ng-container *ngIf="!uiPlaceHolderTemplate">
  <ng-container *nzStringTemplateOutlet="placeholder">
    {{ placeholder }}
  </ng-container>
</ng-container>
